import * as React from 'react';

import { __t, applyTranslations } from 'utils/language';

import './contact-us.scss';

applyTranslations(require('./contact-us.i18n.json'));


const ContactUs = (): JSX.Element => (
  <div className="contact-us">
    <span
      dangerouslySetInnerHTML={{ __html: __t('contact_us.queries') }}
    />
    <span
      className="contact-us-chat-link"
      dangerouslySetInnerHTML={{ __html: __t('contact_us.chat') }}
      onClick={() => {
        const Intercom = window.Intercom;

        if (!Intercom) {
          return;
        }

        Intercom('showMessages');
      }}
    />
    <span
      dangerouslySetInnerHTML={{ __html: __t('contact_us.email') }}
    />
  </div>
);

export default ContactUs;
